import {TFunction} from "react-i18next";
import {FilterButton} from "../../../models/filtered-table/filtered.table";
import {StatementPaymentStatus, StatementType} from "../../../models/accounting/statements";

export const filterButtonsFactory = (t: TFunction<"translation">): FilterButton[] => {
    return [
        {
            label: t('STATEMENTS.FILTERS.ALL'),
            name: 'all',
            states: []
        },
        {
            label: t('STATEMENTS.FILTERS.UNPAID_INVOICES'),
            name: 'unpaid_invoices',
            states: [
                {key: 'type', type: 'select', queryType: '', values: [StatementType.INVOICE]},
                {key: 'status', type: 'select', queryType: '', values: [StatementPaymentStatus.OVERDUE, StatementPaymentStatus.AWAITING]},
            ]
        },
        {
            label: t('STATEMENTS.FILTERS.OVERDUE_INVOICES'),
            name: 'overpaid_invoices',
            states: [
                {key: 'type', type: 'select', queryType: '', values: [StatementType.INVOICE]},
                {key: 'status', type: 'select', queryType: '', values: [StatementPaymentStatus.OVERPAID]},
            ]
        }, {
            label: t('STATEMENTS.FILTERS.CREDITS'),
            name: 'credits',
            states: [
                {key: 'type', type: 'select', queryType: '', values: [StatementType.CREDIT_INVOICE]},
                {key: 'status', type: 'select', queryType: '', values: [StatementPaymentStatus.AWAITING]},
            ]
        }
    ];
}